import { render, staticRenderFns } from "./CardReports.vue?vue&type=template&id=6c25d0b7&scoped=true&"
import script from "./CardReports.vue?vue&type=script&lang=js&"
export * from "./CardReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c25d0b7",
  null
  
)

export default component.exports